// extracted by mini-css-extract-plugin
export default {"left":"K1ox","right-name":"Hlqv","rightName":"Hlqv","right":"L_kv","secret-inspector":"iWps","secretInspector":"iWps","description":"xtCw"};